/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowsCross: {
  name: 'arrows-cross';
  data: string;
} = {
  name: 'arrows-cross',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.707 4.293a1 1 0 0 0-1.414 1.414L10.586 12l-6.293 6.293a1 1 0 1 0 1.414 1.414l7-7L18 7.414V9a1 1 0 1 0 2 0V5a1 1 0 0 0-1-1h-4a1 1 0 1 0 0 2h1.586L12 10.586 5.707 4.293ZM18 16.586l-3.293-3.293a1 1 0 0 0-1.414 1.414L16.586 18H15a1 1 0 1 0 0 2h4a1 1 0 0 0 1-1v-4a1 1 0 1 0-2 0v1.586Z" fill="currentColor"/></svg>`,
};
